// UserProfileStage2.js
import React, { useState, useEffect } from "react";
import {
  FaBriefcase,
  FaGraduationCap,
  FaCertificate,
  FaAward,
  FaBook,
  FaUsers,
  FaFileAlt,
  FaIdCard,
  FaTools,
  FaUserTie,
  FaBuilding,
  FaClock,
  FaCheckCircle,
  FaTimesCircle,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaLink,
  FaUserCircle,
  FaShieldAlt,
  FaGlobe,
  FaChevronDown,
  FaChevronUp,
  FaStar,
  FaChartLine,
  FaMedal,
  FaTrophy,
  FaLanguage,
  FaCog,
} from "react-icons/fa";
import axios from "axios";
import { API_BASE } from "../../../ApiUrl";
import "./UserProfileStage2.css";

const UserProfileStage2 = ({ professionalId }) => {
  const [stage2Data, setStage2Data] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    employment: true,
    projects: false,
    credentials: false,
    capabilities: false,
    contacts: false,
    reviews: false,
  });

  useEffect(() => {
    if (professionalId) {
      fetchStage2Data(professionalId);
    }
  }, [professionalId]);

  const fetchStage2Data = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE}/professional-profiles/${id}/related-records/`
      );
      if (response.data.success) {
        setStage2Data(response.data.data);
        console.log("Stage 2 Data:", response.data.data);
      } else {
        setError("Failed to load Stage 2 data");
      }
    } catch (err) {
      console.error("Error fetching Stage 2 data:", err);
      setError("Error loading Stage 2 details");
    } finally {
      setLoading(false);
    }
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  if (loading) {
    return (
      <div className="up-loading-container">
        <div className="up-loading-spinner"></div>
        <p>Loading professional records...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="up-error-container">
        <p className="up-error-text">{error}</p>
        <button
          onClick={() => fetchStage2Data(professionalId)}
          className="up-retry-btn"
        >
          <FaCog className="retry-icon" /> Try Again
        </button>
      </div>
    );
  }

  if (!stage2Data) {
    return (
      <div className="up-empty-state">
        <div className="empty-icon-wrapper">
          <FaFileAlt className="empty-icon" />
        </div>
        <p>No professional records found</p>
        <span className="empty-subtext">
          Complete your professional profile to showcase your experience
        </span>
      </div>
    );
  }

  const {
    employment_records = [],
    project_records = [],
    credentials = [],
    capabilities = [],
    contacts = [],
    reviews = [],
  } = stage2Data;

  const formatDate = (date) => {
    if (!date) return "—";
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getRecordTypeIcon = (type) => {
    const icons = {
      EDUCATION: <FaGraduationCap />,
      CERTIFICATION: <FaCertificate />,
      AWARD: <FaAward />,
      PUBLICATION: <FaBook />,
      MEMBERSHIP: <FaUsers />,
      MARINE_COC: <FaStar />,
      MARINE_CDC: <FaIdCard />,
      PASSPORT: <FaIdCard />,
      MEDICAL_FITNESS: <FaShieldAlt />,
      DEFAULT: <FaFileAlt />,
    };
    return icons[type] || icons.DEFAULT;
  };

  const getStatusColor = (status) => {
    const colors = {
      ACTIVE: "#28a745",
      APPROVED: "#28a745",
      EXPIRED: "#dc3545",
      REJECTED: "#dc3545",
      ARCHIVED: "#6c757d",
      DRAFT: "#ffc107",
      PENDING: "#ffc107",
      SELF_DECLARED: "#17a2b8",
      EVIDENCE_UPLOADED: "#007bff",
    };
    return colors[status] || "#6c757d";
  };

  const getStatusBadgeClass = (status) => {
    const classes = {
      ACTIVE: "badge-active",
      APPROVED: "badge-approved",
      EXPIRED: "badge-expired",
      REJECTED: "badge-rejected",
      ARCHIVED: "badge-archived",
      DRAFT: "badge-draft",
      PENDING: "badge-pending",
      SELF_DECLARED: "badge-info",
      EVIDENCE_UPLOADED: "badge-primary",
    };
    return classes[status] || "badge-default";
  };

  const getStatusIcon = (status) => {
    const icons = {
      ACTIVE: <FaCheckCircle />,
      APPROVED: <FaCheckCircle />,
      EXPIRED: <FaTimesCircle />,
      REJECTED: <FaTimesCircle />,
      ARCHIVED: <FaClock />,
      DRAFT: <FaClock />,
      PENDING: <FaClock />,
    };
    return icons[status] || null;
  };

  const totalRecords =
    employment_records.length +
    project_records.length +
    credentials.length +
    capabilities.length +
    contacts.length +
    reviews.length;

  return (
    <div className="up-stage2-container">
      {/* Header */}
      {/* <div className="up-stage2-header">
        <div className="up-stage2-header-content">
          <div className="up-stage2-header-left">
            <div className="up-stage2-header-icon">
              <FaBriefcase />
            </div>
            <div>
              <h2 className="up-stage2-header-title">Professional Records</h2>
              <p className="up-stage2-header-subtitle">
                Complete professional history including employment, projects, credentials, and capabilities
              </p>
            </div>
          </div>
          <div className="up-stage2-header-right">
            <div className="up-stage2-stats">
              <span className="stat-badge">
                <FaBriefcase /> {employment_records.length} Employment
              </span>
              <span className="stat-badge">
                <FaUserTie /> {project_records.length} Projects
              </span>
              <span className="stat-badge">
                <FaGraduationCap /> {credentials.length} Credentials
              </span>
              <span className="stat-badge">
                <FaTools /> {capabilities.length} Skills
              </span>
            </div>
          </div>
        </div>
      </div> */}

      {/* Stats Overview Cards */}
      {/* <div className="up-stage2-stats-grid">
        <div className="stat-card">
          <div className="stat-card-icon employment-icon">
            <FaBriefcase />
          </div>
          <div className="stat-card-content">
            <span className="stat-number">{employment_records.length}</span>
            <span className="stat-label">Employment</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-icon projects-icon">
            <FaUserTie />
          </div>
          <div className="stat-card-content">
            <span className="stat-number">{project_records.length}</span>
            <span className="stat-label">Projects</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-icon credentials-icon">
            <FaGraduationCap />
          </div>
          <div className="stat-card-content">
            <span className="stat-number">{credentials.length}</span>
            <span className="stat-label">Credentials</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-icon capabilities-icon">
            <FaTools />
          </div>
          <div className="stat-card-content">
            <span className="stat-number">{capabilities.length}</span>
            <span className="stat-label">Capabilities</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-icon contacts-icon">
            <FaUsers />
          </div>
          <div className="stat-card-content">
            <span className="stat-number">{contacts.length}</span>
            <span className="stat-label">Contacts</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-icon reviews-icon">
            <FaFileAlt />
          </div>
          <div className="stat-card-content">
            <span className="stat-number">{reviews.length}</span>
            <span className="stat-label">Reviews</span>
          </div>
        </div>
      </div> */}

      {/* Employment Records Section */}
      {employment_records.length > 0 && (
        <div className="up-stage2-section">
          <div
            className="section-header"
            onClick={() => toggleSection("employment")}
          >
            <div className="section-header-left">
              <div className="section-icon-wrapper employment-icon">
                <FaBriefcase />
              </div>
              <h3>Employment Records</h3>
              <span className="section-count">{employment_records.length}</span>
            </div>
            <div className="section-toggle">
              {expandedSections.employment ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>

          {expandedSections.employment && (
            <div className="up-stage2-grid">
              {employment_records.map((record, index) => (
                <div className="up-stage2-card" key={record.id || index}>
                  <div className="card-header-with-status">
                    <div className="card-title-section">
                      <h4>{record.job_title || "Position"}</h4>
                      <p className="company-name">
                        {record.employer_name_snapshot || "Employer"}
                      </p>
                    </div>
                    <div className="card-status">
                      {getStatusIcon(record.status)}
                      <span
                        className={`badge ${getStatusBadgeClass(record.status)}`}
                      >
                        {record.status}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="info-grid">
                      <div className="info-item">
                        <FaMapMarkerAlt className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Location</span>
                          <span className="info-value">
                            {record.city}, {record.country_code || "—"}
                          </span>
                        </div>
                      </div>
                      <div className="info-item">
                        <FaCalendarAlt className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Period</span>
                          <span className="info-value">
                            {formatDate(record.start_date)} -{" "}
                            {record.is_current
                              ? "Present"
                              : formatDate(record.end_date)}
                          </span>
                        </div>
                      </div>
                      {record.duties && (
                        <div className="info-item full-width">
                          <FaFileAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Duties</span>
                            <span className="info-value">{record.duties}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Project Records Section */}
      {project_records.length > 0 && (
        <div className="up-stage2-section">
          <div
            className="section-header"
            onClick={() => toggleSection("projects")}
          >
            <div className="section-header-left">
              <div className="section-icon-wrapper projects-icon">
                <FaUserTie />
              </div>
              <h3>Project Records</h3>
              <span className="section-count">{project_records.length}</span>
            </div>
            <div className="section-toggle">
              {expandedSections.projects ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>

          {expandedSections.projects && (
            <div className="up-stage2-grid">
              {project_records.map((project, index) => (
                <div className="up-stage2-card" key={project.id || index}>
                  <div className="card-header-with-status">
                    <div className="card-title-section">
                      <h4>{project.project_name || "Project"}</h4>
                      <p className="company-name">
                        {project.client_organization || "Client"}
                      </p>
                    </div>
                    <div className="card-status">
                      {getStatusIcon(project.status)}
                      <span
                        className={`badge ${getStatusBadgeClass(project.status)}`}
                      >
                        {project.status}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="info-grid">
                      <div className="info-item">
                        <FaBuilding className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Employer</span>
                          <span className="info-value">
                            {project.employer_organization || "—"}
                          </span>
                        </div>
                      </div>
                      <div className="info-item">
                        <FaMapMarkerAlt className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Location</span>
                          <span className="info-value">
                            {project.city}, {project.country_code || "—"}
                          </span>
                        </div>
                      </div>
                      <div className="info-item">
                        <FaCalendarAlt className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Duration</span>
                          <span className="info-value">
                            {formatDate(project.start_date)} -{" "}
                            {project.is_current
                              ? "Present"
                              : formatDate(project.end_date)}
                          </span>
                        </div>
                      </div>
                      <div className="info-item">
                        <FaClock className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Allocation</span>
                          <span className="info-value">
                            {project.allocation_percent}%
                          </span>
                        </div>
                      </div>
                      {project.responsibilities && (
                        <div className="info-item full-width">
                          <FaFileAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Responsibilities</span>
                            <span className="info-value">
                              {project.responsibilities}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Credentials Section */}
      {credentials.length > 0 && (
        <div className="up-stage2-section">
          <div
            className="section-header"
            onClick={() => toggleSection("credentials")}
          >
            <div className="section-header-left">
              <div className="section-icon-wrapper credentials-icon">
                <FaGraduationCap />
              </div>
              <h3>Credentials & Certifications</h3>
              <span className="section-count">{credentials.length}</span>
            </div>
            <div className="section-toggle">
              {expandedSections.credentials ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>

          {expandedSections.credentials && (
            <div className="up-stage2-grid">
              {credentials.map((credential, index) => (
                <div className="up-stage2-card" key={credential.id || index}>
                  <div className="card-header-with-status">
                    <div className="card-title-section">
                      <div className="credential-type-badge">
                        {getRecordTypeIcon(credential.record_type)}
                        <span>{credential.record_type}</span>
                      </div>
                      <h4>{credential.title || "Credential"}</h4>
                      <p className="company-name">
                        {credential.issuing_body_snapshot || "Issuer"}
                      </p>
                    </div>
                    <div className="card-status">
                      {getStatusIcon(credential.status)}
                      <span
                        className={`badge ${getStatusBadgeClass(credential.status)}`}
                      >
                        {credential.status}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="info-grid">
                      <div className="info-item">
                        <FaGlobe className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Country</span>
                          <span className="info-value">
                            {credential.issuing_country_code || "—"}
                          </span>
                        </div>
                      </div>
                      {credential.level_or_grade && (
                        <div className="info-item">
                          <FaShieldAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Level</span>
                            <span className="info-value">
                              {credential.level_or_grade}
                            </span>
                          </div>
                        </div>
                      )}
                      {credential.issue_date && (
                        <div className="info-item">
                          <FaCalendarAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Issued</span>
                            <span className="info-value">
                              {formatDate(credential.issue_date)}
                            </span>
                          </div>
                        </div>
                      )}
                      {credential.expiry_date && (
                        <div className="info-item">
                          <FaClock className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Expires</span>
                            <span className="info-value">
                              {formatDate(credential.expiry_date)}
                            </span>
                          </div>
                        </div>
                      )}
                      {credential.details?.linked_scope && (
                        <div className="info-item full-width">
                          <FaLink className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Scope</span>
                            <span className="info-value">
                              {credential.details.linked_scope}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Capabilities Section */}
      {capabilities.length > 0 && (
        <div className="up-stage2-section">
          <div
            className="section-header"
            onClick={() => toggleSection("capabilities")}
          >
            <div className="section-header-left">
              <div className="section-icon-wrapper capabilities-icon">
                <FaTools />
              </div>
              <h3>Capabilities & Skills</h3>
              <span className="section-count">{capabilities.length}</span>
            </div>
            <div className="section-toggle">
              {expandedSections.capabilities ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>

          {expandedSections.capabilities && (
            <div className="up-stage2-grid capabilities-grid">
              {capabilities.map((capability, index) => (
                <div className="up-stage2-card capability-card" key={capability.id || index}>
                  <div className="card-header-with-status">
                    <div className="card-title-section">
                      <span className="capability-type-badge">
                        {capability.capability_type}
                      </span>
                      <h4>{capability.custom_name || "Skill"}</h4>
                    </div>
                    <div className="card-status">
                      <span
                        className={`badge ${getStatusBadgeClass(capability.verification_status)}`}
                      >
                        {capability.verification_status}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="info-grid">
                      {capability.proficiency && (
                        <div className="info-item">
                          <FaShieldAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Proficiency</span>
                            <span className="info-value">
                              {capability.proficiency}
                            </span>
                          </div>
                        </div>
                      )}
                      {capability.years_experience && (
                        <div className="info-item">
                          <FaClock className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Years Experience</span>
                            <span className="info-value">
                              {capability.years_experience}
                            </span>
                          </div>
                        </div>
                      )}
                      {capability.last_used_date && (
                        <div className="info-item">
                          <FaCalendarAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Last Used</span>
                            <span className="info-value">
                              {formatDate(capability.last_used_date)}
                            </span>
                          </div>
                        </div>
                      )}
                      {capability.speaking_level && (
                        <div className="info-item">
                          <FaEnvelope className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Speaking</span>
                            <span className="info-value">
                              {capability.speaking_level}
                            </span>
                          </div>
                        </div>
                      )}
                      {capability.reading_level && (
                        <div className="info-item">
                          <FaBook className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Reading</span>
                            <span className="info-value">
                              {capability.reading_level}
                            </span>
                          </div>
                        </div>
                      )}
                      {capability.writing_level && (
                        <div className="info-item">
                          <FaFileAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Writing</span>
                            <span className="info-value">
                              {capability.writing_level}
                            </span>
                          </div>
                        </div>
                      )}
                      {capability.edition_or_model && (
                        <div className="info-item full-width">
                          <FaLink className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Edition/Model</span>
                            <span className="info-value">
                              {capability.edition_or_model}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Contacts Section */}
      {contacts.length > 0 && (
        <div className="up-stage2-section">
          <div
            className="section-header"
            onClick={() => toggleSection("contacts")}
          >
            <div className="section-header-left">
              <div className="section-icon-wrapper contacts-icon">
                <FaUsers />
              </div>
              <h3>Professional Contacts</h3>
              <span className="section-count">{contacts.length}</span>
            </div>
            <div className="section-toggle">
              {expandedSections.contacts ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>

          {expandedSections.contacts && (
            <div className="up-stage2-grid contacts-grid">
              {contacts.map((contact, index) => (
                <div className="up-stage2-card contact-card" key={contact.id || index}>
                  <div className="card-header-with-status">
                    <div className="card-title-section">
                      <h4>{contact.full_name || "Contact"}</h4>
                      <p className="company-name">{contact.contact_type}</p>
                    </div>
                    <div className="card-status">
                      <span
                        className={`consent-badge ${contact.consent_given ? "granted" : "denied"}`}
                      >
                        {contact.consent_given ? "✓ Consent Given" : "✗ No Consent"}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="info-grid">
                      {contact.job_title && (
                        <div className="info-item">
                          <FaUserTie className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Job Title</span>
                            <span className="info-value">{contact.job_title}</span>
                          </div>
                        </div>
                      )}
                      {contact.organization_name_snapshot && (
                        <div className="info-item">
                          <FaBuilding className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Organization</span>
                            <span className="info-value">
                              {contact.organization_name_snapshot}
                            </span>
                          </div>
                        </div>
                      )}
                      {contact.relationship && (
                        <div className="info-item">
                          <FaUserCircle className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Relationship</span>
                            <span className="info-value">{contact.relationship}</span>
                          </div>
                        </div>
                      )}
                      {contact.email && (
                        <div className="info-item">
                          <FaEnvelope className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Email</span>
                            <span className="info-value">
                              <a href={`mailto:${contact.email}`}>{contact.email}</a>
                            </span>
                          </div>
                        </div>
                      )}
                      {contact.phone && (
                        <div className="info-item">
                          <FaPhone className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Phone</span>
                            <span className="info-value">{contact.phone}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Reviews Section */}
      {reviews.length > 0 && (
        <div className="up-stage2-section">
          <div
            className="section-header"
            onClick={() => toggleSection("reviews")}
          >
            <div className="section-header-left">
              <div className="section-icon-wrapper reviews-icon">
                <FaFileAlt />
              </div>
              <h3>Reviews & Assessments</h3>
              <span className="section-count">{reviews.length}</span>
            </div>
            <div className="section-toggle">
              {expandedSections.reviews ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>

          {expandedSections.reviews && (
            <div className="up-stage2-grid reviews-grid">
              {reviews.map((review, index) => (
                <div className="up-stage2-card review-card" key={review.id || index}>
                  <div className="card-header-with-status">
                    <div className="card-title-section">
                      <h4>{review.review_type || "Review"}</h4>
                    </div>
                    <div className="card-status">
                      {getStatusIcon(review.decision)}
                      <span
                        className={`badge ${getStatusBadgeClass(review.decision)}`}
                      >
                        {review.decision}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="info-grid">
                      <div className="info-item">
                        <FaCalendarAlt className="info-icon" />
                        <div className="info-content">
                          <span className="info-label">Submitted</span>
                          <span className="info-value">
                            {formatDate(review.submitted_at)}
                          </span>
                        </div>
                      </div>
                      {review.reviewer_notes && (
                        <div className="info-item full-width">
                          <FaFileAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Notes</span>
                            <span className="info-value">{review.reviewer_notes}</span>
                          </div>
                        </div>
                      )}
                      {review.decision_reason && (
                        <div className="info-item full-width">
                          <FaShieldAlt className="info-icon" />
                          <div className="info-content">
                            <span className="info-label">Reason</span>
                            <span className="info-value">{review.decision_reason}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {totalRecords === 0 && (
        <div className="up-empty-state">
          <div className="empty-icon-wrapper">
            <FaFileAlt className="empty-icon" />
          </div>
          <p>No professional records found</p>
          <span className="empty-subtext">
            Complete your profile to showcase your experience
          </span>
        </div>
      )}
    </div>
  );
};

export default UserProfileStage2;